<div class="container">
  <h1 class="section-title">{{ 'certificate.approval.title' | translate }}</h1>
  <div class="form-column half-width" *ngIf="!showCertificateForm">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'certificate.pin_info.enter_pin' | translate }}</mat-label>
      <input
        class="input-filed"
        type="text"
        matInput
        data-testid="device-registration-pin"
        [(ngModel)]="certificatePin"
      />
    </mat-form-field>
    <div class="button-box">
      <app-button
        testId="device-registration-get-info"
        [disabled]="!hasCertificatePinInput"
        (click)="getInfoFromPin()"
        [tall]="true"
        [title]="'certificate.get_info.button' | translate"
      >
      </app-button>
      <app-button
        *ngIf="isSuperAdmin"
        [disabled]="!hasCertificatePinInput"
        (click)="searchAssociations()"
        [title]="'button.search.submit' | translate"
      >
      </app-button>
    </div>
    <div class="search-results" *ngIf="isSuperAdmin && searchHasAttempted">
      <h3 class="search-results-title">
        {{ 'certificate.search.results_title' | translate }}
      </h3>
      <p class="search-results-loading" *ngIf="certificateStore.loading()">
        {{ 'certificate.search.loading' | translate }}
      </p>
      <p class="search-results-empty" *ngIf="showNoSearchResults">
        {{ 'certificate.search.no_results' | translate }}
      </p>
      <div
        class="search-result-card"
        role="button"
        tabindex="0"
        *ngFor="let result of searchResults; trackBy: trackBySearchResult"
        (click)="selectAssociation(result)"
        (keydown.enter)="selectAssociation(result)"
        (keydown.space)="selectAssociation(result)"
      >
        <div class="search-result-card-main">
          <div class="search-result-card-identity">
            <span class="search-result-card-title">{{
              result.deviceId ?? '-'
            }}</span>
            <span class="search-result-card-subtitle">{{
              result.deviceType ?? '-'
            }}</span>
          </div>
        </div>
        <div class="search-result-card-meta">
          <div class="search-result-card-meta-item">
            <span class="search-result-card-meta-label">{{
              'certificate.createdAt.input' | translate
            }}</span>
            <span class="search-result-card-meta-value">{{
              formatTimestamp(result.createdAt)
            }}</span>
          </div>
          <div class="search-result-card-meta-item">
            <span class="search-result-card-meta-label">{{
              'certificate.creator.input' | translate
            }}</span>
            <span class="search-result-card-meta-value">{{
              result.creator?.email ?? '-'
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <span
    *ngIf="errorMessage"
    class="error-message"
    data-testid="device-registration-key-error"
  >
    {{ errorMessage }}
  </span>

  <div *ngIf="showCertificateForm">
    <h2 class="section-sub-title">
      {{ 'certificate.approval.verify' | translate }}
    </h2>

    <div *ngIf="hasExistingRegisteredDevice" class="existing-device half-width">
      <h3 class="existing-device-title">
        {{ 'certificate.existing_device.title' | translate }}
      </h3>
      <p class="existing-device-message">
        {{ 'certificate.existing_device.message' | translate }}
      </p>
      <div class="existing-device-details">
        <div>
          <span class="existing-device-label">
            {{ 'certificate.existing_device.name' | translate }}
          </span>
          <a
            *ngIf="existingDeviceId; else existingDeviceNameText"
            class="existing-device-value existing-device-link"
            [routerLink]="['/device', existingDeviceId]"
            target="_blank"
            rel="noopener"
          >
            {{ existingDeviceName }}
          </a>
          <ng-template #existingDeviceNameText>
            <span class="existing-device-value">{{ existingDeviceName }}</span>
          </ng-template>
        </div>
        <div>
          <span class="existing-device-label">
            {{ 'certificate.existing_device.company' | translate }}
          </span>
          <span class="existing-device-value">
            {{ existingDeviceCompany }}
          </span>
        </div>
        <div *ngIf="existingDeviceLicenseBatches.length > 0">
          <span class="existing-device-label">
            {{ 'certificate.existing_device.licenses' | translate }}
          </span>
          <span class="existing-device-value">
            {{ existingDeviceLicenseNames }}
          </span>
        </div>
      </div>
    </div>

    <div class="form-column half-width certificate-info-container">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificate.pin.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          [(ngModel)]="certificatePin"
          disabled="true"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificate.nameAlias.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          data-testid="device-registration-name-alias"
          [(ngModel)]="associationRequest.nameAlias"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificate.deviceId.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          [value]="certificateInfo?.deviceId ?? ''"
          [disabled]="true"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificate.deviceIp.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          [value]="deviceIp"
          [disabled]="true"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificate.currentIp.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          [value]="currentIp"
          [disabled]="true"
        />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificate.deviceType.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          [(ngModel)]="associationRequest.deviceTypeOverride"
          [disabled]="true"
        />
      </mat-form-field>
      <mat-form-field *ngIf="creatorEmail" appearance="outline">
        <mat-label>{{ 'certificate.creator.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          [value]="creatorEmail"
          [disabled]="true"
        />
      </mat-form-field>
      <div class="full-width">
        <app-autocomplete
          [data]="companies"
          [label]="'certificate.companyId.input' | translate"
          [isRequired]="true"
          [preSelectedValue]="companyPreSelectedValue"
          [disabled]="!isSuperAdmin"
          propertyName="name"
          [formatterFn]="companyFormatter"
          (valueSelected)="onCompanySelected($event)"
        ></app-autocomplete>
        <span
          *ngIf="showValidationErrors && isCompanyIdMissing"
          class="error-message"
        >
          {{ 'certificate.companyId.required' | translate }}
        </span>
        <div
          *ngIf="willMoveExistingDevice || willReleaseExistingDeviceLicenses"
          class="existing-device-move-warning"
          role="alert"
        >
          <p *ngIf="willMoveExistingDevice">
            {{
              'certificate.existing_device.move_warning'
                | translate
                  : { from: existingDeviceCompany, to: selectedCompanyName }
            }}
          </p>
          <p *ngIf="willReleaseExistingDeviceLicenses">
            {{ 'certificate.existing_device.licenses_released' | translate }}
          </p>
        </div>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificate.note.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          [(ngModel)]="associationRequest.note"
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'certificate.createdAt.input' | translate }}</mat-label>
        <input
          class="input-filed"
          type="text"
          matInput
          [value]="createdAt"
          [disabled]="true"
        />
      </mat-form-field>
    </div>
    <div class="button-box half-width">
      <app-button
        [disabled]="!certificatePin"
        (click)="cancel()"
        [title]="'certificate.cancel.button' | translate"
      >
      </app-button>
      <app-button
        testId="device-registration-approve"
        [disabled]="!canApprove"
        (click)="approveCertificate()"
        [tall]="true"
        [title]="'certificate.approve.button' | translate"
      >
      </app-button>
    </div>
  </div>
</div>
